import { DiffEditor } from "@monaco-editor/react";
import { create, show } from "@ebay/nice-modal-react";

import ModalContent from "ds/components/Modal/Content";
import ModalHeader from "ds/components/Modal/Header";
import ModalSimple from "ds/components/ModalSimple";
import useTypedContext from "hooks/useTypedContext";
import { ThemeContext } from "views/Theme";

import styles from "./styles.module.css";

type PolicyDiffCalloutModalProps = {
  body: string;
  evaluationBody: string;
};

const PolicyDiffCalloutModal = create(function SettingModal({
  body,
  evaluationBody,
}: PolicyDiffCalloutModalProps) {
  const { isDarkMode, currentDarkModeSyntaxTheme, currentLightModeSyntaxTheme } =
    useTypedContext(ThemeContext);

  return (
    <ModalSimple size="large">
      <ModalHeader title="Policy body changes" />
      <ModalContent>
        <div className={styles.diffEditorWrapper}>
          <DiffEditor
            original={body}
            modified={evaluationBody}
            language="rego"
            theme={isDarkMode ? currentDarkModeSyntaxTheme : currentLightModeSyntaxTheme}
            keepCurrentOriginalModel={true}
            keepCurrentModifiedModel={true}
          />
        </div>
      </ModalContent>
    </ModalSimple>
  );
});

export const showPolicyDiffCalloutModal = (props: PolicyDiffCalloutModalProps) =>
  show(PolicyDiffCalloutModal, props);
